import React from "react";
import { Button, Grid2 } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { SenszClientServices } from "../../../ApiServices/http-common";
import { useWasteManagement } from "../../../ContextAPI/WasteManagementContext";
import dayjs from "dayjs";
import { showToast } from "../../../CommonComponents/ToastBox";
import { useTranslation } from "react-i18next";
import { useMasterData } from "../../../ContextAPI/MasterContext";

const ExportBinPage: React.FC = () => {
  const { masterState } = useMasterData();
  const { wasteManagementState, dispatchWasteManagement } =
    useWasteManagement();
  const { t } = useTranslation();
  const handleExport = async (
    siteCode: string,
    fromDate: string,
    groupId: string
  ): Promise<void> => {
    if (wasteManagementState.siteData.length <= 0) {
      showToast("No data available to export.", "warning");
      return;
    }
    try {
      const response = await SenszClientServices.get(
        `report/${siteCode}/binoverview/download`,
        {
          params: {
            fromDate: fromDate,
            groupId: groupId,
          },

          responseType: "blob", // Ensures that the response data is in binary format
        }
      );

      showToast("Data Exported.", "success");

      // Create a URL for the file download
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const currentDateAndTime: string = dayjs().format("YYYYMMDDHHmmss");
      const fileName: string = `bin_overview_report_${currentDateAndTime}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); // Set the file name

      document.body.appendChild(link);
      link.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {}
  };

  const formattedDate: string = masterState.reportSelectedDate
    ? masterState.reportSelectedDate.format("YYYY-MM-DD")
    : "";

  return (
    <Grid2
      container
      justifyContent="flex-end" // Aligns items to the end of the grid
      alignItems="center"
      sx={{ padding: 0.5,mr:1 }} // Optional: Add padding around the grid
    >
      <Button
        variant="contained"
        color="secondary"
        startIcon={<FileDownloadIcon />}
        onClick={() =>
          handleExport(
            masterState.selectedSiteCode,
            formattedDate,
            masterState.selectedGroupCode
          )
        }
        style={{
          backgroundColor: "#8850EF", // Purple color similar to your image
          color: "#fff",
        }}
      >
        {t("global.Export")}
      </Button>
    </Grid2>
  );
};
export default ExportBinPage;
